// extracted by mini-css-extract-plugin
export default {"headLines":"index_headLines_dvrwb"};